<template>
  <vue-draggable
    v-if="editMode"
    :value="children"
    :group="dragGroup"
    :disabled="!editMode"
    :animation="150"
    ghost-class="sortable-ghost"
    drag-class="sortable-drag"
    @change="handleDragChange"
    @start="onDragStart"
    @end="onDragEnd"
    class="page-node-children"
  >
    <page-node-wrapper
      v-for="node in children"
      :key="node.id"
      :node="node"
      :edit-mode="editMode"
    />
  </vue-draggable>
  <div v-else class="page-node-children">
    <page-node-wrapper
      v-for="node in children"
      :key="node.id"
      :node="node"
      :edit-mode="editMode"
    />
  </div>
</template>

<script>
import VueDraggable from 'vuedraggable';
import { mapGetters, mapActions } from 'vuex';
import PageNodeWrapper from './PageNodeWrapper.vue';

export default {
  name: 'PageNodeChildren',
  components: { VueDraggable, PageNodeWrapper },
  props: {
    pageId: { type: String, required: true },
    parentId: { type: String, default: null },
    editMode: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('pages', ['childrenOf']),
    children() {
      return this.childrenOf(this.parentId, this.pageId);
    },
    dragGroup() {
      return {
        name: 'page-nodes',
        pull: true,
        put: () => {
          // Check droppable prop on parent
          if (!this.parentId) return true;
          const targetNode = this.$store.getters['pages/nodeById'](
            this.parentId
          );
          return targetNode?.droppable !== false;
        },
      };
    },
  },
  methods: {
    ...mapActions('pages', ['applyUpdate']),
    handleDragChange(e) {
      console.log('[PageNodeChildren] drag change:', e);
      if (e.moved) {
        const { element, newIndex } = e.moved;
        const afterId = newIndex > 0 ? this.children[newIndex - 1]?.id : null;
        this.applyUpdate({
          id: element.id,
          op: 'move',
          newParentId: this.parentId,
          afterId,
        });
      }
      if (e.added) {
        const { element, newIndex } = e.added;
        const afterId = newIndex > 0 ? this.children[newIndex - 1]?.id : null;
        this.applyUpdate({
          id: element.id,
          op: 'move',
          newParentId: this.parentId,
          afterId,
        });
      }
    },
    onDragStart(e) {
      console.log('[PageNodeChildren] drag start:', e);
    },
    onDragEnd(e) {
      console.log('[PageNodeChildren] drag end:', e);
    },
  },
};
</script>

<style lang="less">
.page-node-children {
  min-height: 20px;

  &.sortable-ghost {
    opacity: 0.5;
  }
}
</style>
